<template>
    <div class="recharge_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.go(-1)"></div>
            <div class="big_tit">实名认证</div>
        </div>
        <div class="wrap_box warp1">
            <!-- 姓名 -->
            <div class="item">
                <div class="ari_font">姓名：</div>
                <input
                    class="card"
                    type="text"
                    v-model="name"
                    placeholder="请输入姓名"
                />
            </div>
            <!-- 身份证号码 -->
            <div class="item">
                <div class="ari_font">身份证号码：</div>
                <input
                    class="card"
                    type="text"
                    v-model="idcard"
                    placeholder="请输入身份证号码"
                />
            </div>
            <!-- 上传身份证正反面 -->
            <div class="qrcode_row">
                <div class="qrcode">
                    <div>上传身份证正面</div>
                    <div class="qrcode_img">
                        <van-uploader
                            v-model="zidcardFileList"
                            multiple
                            :max-count="1"
                            class="upload"
                            :max-size="2 * 1024 * 1024"
                            @oversize="onOversize"
                            :after-read="afterReadZidcard"
                            :before-read="beforeRead"
                        ></van-uploader>
                    </div>
                </div>
                <div class="qrcode">
                    <div>上传身份证反面</div>
                    <div class="qrcode_img">
                        <van-uploader
                            v-model="fidcardFileList"
                            multiple
                            :max-count="1"
                            class="upload"
                            :max-size="2 * 1024 * 1024"
                            @oversize="onOversize"
                            :after-read="afterReadFidcard"
                            :before-read="beforeRead"
                        ></van-uploader>
                    </div>
                </div>
            </div>
        </div>
        <div class="basic_btn" @click="submitBtn">提交认证</div>

        <!-- 确认弹窗 -->
        <van-dialog
            v-model="showConfirmDialog"
            title="确认信息"
            show-cancel-button
            cancel-button-text="取消"
            confirm-button-text="确认"
            @confirm="confirmSubmit"
        >
            我已检查填写的信息真实无误并且提交审核
        </van-dialog>
    </div>
</template>

<script>
    import Vue from "vue";
    import Fetch from "../../utils/fetch";
    import Api from "../../interface/index";
    import { Overlay, Uploader, Button, Toast, Dialog } from "vant";
    import axios from "axios";

    Vue.use(Overlay).use(Uploader).use(Button).use(Dialog);

    export default {
        name: "authshiming",
        data() {
            return {
                name: "", // 姓名
                idcard: "", // 身份证号码
                zidcard: "", // 身份证正面图片路径
                fidcard: "", // 身份证反面图片路径
                zidcardFileList: [], // 身份证正面文件列表
                fidcardFileList: [], // 身份证反面文件列表
                showConfirmDialog: false, // 控制确认弹窗显示
            };
        },
        methods: {
            // 提交实名认证
            submitBtn() {
                // 校验信息是否完整
                if (!this.name || !this.idcard || !this.zidcard || !this.fidcard) {
                    this.$toast("实名认证信息不完整，请输入完整后提交");
                    return;
                }

                // 显示确认弹窗
                this.showConfirmDialog = true;
            },
            // 确认提交
            confirmSubmit() {
                // 提交数据
                Fetch("/user/real_name_auth", {
                    name: this.name,
                    idcard: this.idcard,
                    zidcard: this.zidcard,
                    fidcard: this.fidcard,
                }).finally(() => {
                    // 返回上一级页面
                    window.location.href = "/";
                });
            },
            // 上传身份证正面图片
            afterReadZidcard(file) {
                let formData = new FormData();
                formData.append("language", this.$i18n.locale || "zh_cn");
                formData.append("file", file.file);
                formData.append("token", localStorage.getItem("token"));
                Toast.loading({
                    forbidClick: true,
                    duration: 20000,
                });
                axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then((r) => {
                    Toast.clear();
                    if (r.data.code === 1) {
                        this.zidcard = r.data.data; // 保存身份证正面图片路径
                    } else {
                        this.$toast(r.data.info || "上传失败");
                    }
                });
            },
            // 上传身份证反面图片
            afterReadFidcard(file) {
                let formData = new FormData();
                formData.append("language", this.$i18n.locale || "zh_cn");
                formData.append("file", file.file);
                formData.append("token", localStorage.getItem("token"));
                Toast.loading({
                    forbidClick: true,
                    duration: 20000,
                });
                axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then((r) => {
                    Toast.clear();
                    if (r.data.code === 1) {
                        this.fidcard = r.data.data; // 保存身份证反面图片路径
                    } else {
                        this.$toast(r.data.info || "上传失败");
                    }
                });
            },
            // 图片大小超出限制
            onOversize(file) {
                this.$toast("图片大小不能超过2MB");
            },
            // 图片格式校验
            beforeRead(file) {
                if (
                    file.type !== "image/jpeg" &&
                    file.type !== "image/jpg" &&
                    file.type !== "image/png"
                ) {
                    this.$toast("仅支持 JPG 或 PNG 格式的图片");
                    return false;
                }
                return true;
            },
        },
    };
</script>

<style lang="less" scoped>
    .back_left {
        background: url(../../views/images/item/back_b.png) no-repeat center center;
    }
    .big_tit {
        color: #333;
    }
    .warp1 {
        margin-top: 12px;

        .item {
            height: 50px;
            padding: 0 16px;
            font-size: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #ececec;

            &:last-child {
                border-bottom: none;
            }
            .card {
                width: 100%;
            }
            input {
                line-height: 14px;
            }
        }
    }
    .ari_font {
        word-break: keep-all;
        white-space: nowrap;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: #333; /* 修改提示文字颜色为深灰色 */
        line-height: 20px;
        margin-right: 5px;
    }
    .basic_btn {
        margin: 30px auto 0 auto; /* 提交按钮向上移动 */
    }
    .qrcode_row {
        display: flex;
        justify-content: space-between;
        padding: 20px 16px;
    }
    .qrcode {
        width: 48%; /* 每个上传区域占一半宽度 */
        text-align: center;
        div {
            color: #333; /* 修改提示文字颜色为深灰色 */
            font-size: 14px;
            margin-bottom: 10px;
        }
        .upload {
            width: 120px; /* 调整上传区域宽度 */
            height: 120px; /* 调整上传区域高度 */
        }
        .qrcode_img {
            width: 120px; /* 调整图片预览宽度 */
            height: 120px; /* 调整图片预览高度 */
            margin: 0 auto;
            background: linear-gradient(
                    to left,
                    #999,
                    #999
                )
                left top no-repeat,
                linear-gradient(to bottom, #999, #999) left top no-repeat,
                linear-gradient(to left, #999, #999) right top no-repeat,
                linear-gradient(to bottom, #999, #999) right top no-repeat,
                linear-gradient(to left, #999, #999) left bottom no-repeat,
                linear-gradient(to bottom, #999, #999) left bottom no-repeat,
                linear-gradient(to left, #999, #999) right bottom no-repeat,
                linear-gradient(to left, #999, #999) right bottom no-repeat;
            background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
            span {
                line-height: 100px;
            }
            img {
                width: 100px;
                height: 100px;
                position: relative;
                top: -100px;
            }
        }
    }
    /* 覆盖 van-uploader__wrapper 的默认样式 */
    .van-uploader__wrapper {
        width: 120px !important; /* 调整宽度 */
        height: 120px !important; /* 调整高度 */
        border-radius: 8px; /* 添加圆角 */
        overflow: hidden;
    }
</style>